import PropTypes from 'prop-types';
import {
  onKeyDownMark,
  BOLD_DEFINITIONS,
} from '@xingternal/content-editor-plugin-helpers';

import { Bold } from './Bold';
import { BOLD_KEYBOARD_SHORTCUT } from './constants';

const BoldPlugin = ({ className, BOLD_TAG, ...attributes } = {}) => ({
  renderLeaf: Bold({ className, BOLD_TAG, ...attributes }),
  onKeyDown: onKeyDownMark({
    mark: BOLD_DEFINITIONS.type,
    hotkey: BOLD_KEYBOARD_SHORTCUT,
  }),
});

BoldPlugin.propTypes = {
  className: PropTypes.string,
  BOLD_TAG: PropTypes.node,
};

export { BoldPlugin };
